import { jsx } from 'react/jsx-runtime';

const SvgActionUpload = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M6 10.73v2.61l5-4.2V19h2V9.14l5 4.2v-2.61l-6-5-6 5ZM21 4V2H3v2h18Z" }) }));

export { SvgActionUpload as default };
//# sourceMappingURL=ActionUpload.es.js.map
